export const newsList = [
  {
    id: 'n1',
    title: '《星际回响》全球票房破十亿，官方正式宣布续集立项',
    summary:
      '上映三周，《星际回响》累计票房正式突破十亿大关，成为本年度口碑与商业双赢的科幻黑马。制片方今日官宣续集启动，原班主创将全员回归。',
    content: [
      '自上映以来，《星际回响》凭借扎实的硬核设定与细腻的情感表达，连续三周稳居票房榜首。截至今日，影片全球累计票房正式突破十亿元人民币，观影人次超过两千四百万。',
      '影片讲述了工程师林知遥在木星轨道接收到来自二十年后的信号，从而展开的一场关于时间与选择的星际迷局。许多观众表示，最打动他们的并非宏大的特效场面，而是主角在"改变过去"与"接受当下"之间的挣扎。',
      '在今日举行的庆功发布会上，制片方正式宣布续集立项，导演陈屿与主演林知遥、周牧野将全员回归。据悉，续集的故事将把镜头对准"回响"信号的真正源头，格局将进一步扩大。',
      '业内人士分析，《星际回响》的成功标志着国产科幻正在从单纯的视觉奇观，走向更具人文深度的叙事表达。',
    ],
    cover: 'https://readdy.ai/api/search-image?query=cinematic%20sci-fi%20space%20station%20and%20glowing%20planet%2C%20news%20article%20header%20visual%2C%20deep%20midnight%20blue%20and%20warm%20orange%20grading%2C%20dramatic%20lighting%2C%20highly%20detailed%2C%20no%20text&width=1200&height=675&seq=yz-n1-cover&orientation=landscape',
    category: 'movie',
    publishedAt: '2026-10-12',
    author: '御宅屋编辑部',
    relatedIds: ['m1', 'm7'],
  },
  {
    id: 'n2',
    title: '年度权谋大剧《长安风云》定档，首支预告片引爆期待',
    summary:
      '备受期待的古装权谋巨制《长安风云》正式宣布定档，首支预告片一经发布便登上热搜，三十六时辰的紧张叙事成为最大看点。',
    content: [
      '由曹盾执导，雷佳音、易烊千玺、周一围联袂主演的《长安风云》今日正式公布档期，并发布首支官方预告片。短短两分钟的预告，将上元灯节前夕长安城的暗流涌动展现得淋漓尽致。',
      '预告片中，繁华的长安城与潜伏的危机形成强烈反差。导演曹盾表示，剧集在置景与服化道上投入了巨大心血，力求还原一个真实、立体、有烟火气的盛唐长安。',
      '不少书迷在看完预告后表示，影像化的长安比想象中更具震撼力，"三十六时辰"的限时叙事结构也让剧集的节奏感备受期待。',
      '该剧共三十六集，将以周播形式上线，御宅屋将持续跟进相关资讯。',
    ],
    cover: 'https://readdy.ai/api/search-image?query=ancient%20chinese%20imperial%20city%20with%20lanterns%20at%20night%2C%20news%20article%20header%20visual%2C%20deep%20midnight%20blue%20and%20warm%20orange%20grading%2C%20dramatic%20lighting%2C%20highly%20detailed%2C%20no%20text&width=1200&height=675&seq=yz-n2-cover&orientation=landscape',
    category: 'tv',
    publishedAt: '2026-10-10',
    author: '追剧小组',
    relatedIds: ['t1', 'm6'],
  },
  {
    id: 'n3',
    title: '《深海迷航》导演专访：如何把恐惧拍进一万米的海底',
    summary:
      '作为本年度最具压迫感的科幻惊悚片，《深海迷航》用声音与光影重新定义了"深海恐惧"。导演郭帆与我们聊了聊创作背后的故事。',
    content: [
      '在《深海迷航》的观影过程中，许多观众表示自己"全程屏住呼吸"。如何在一片漆黑的深海里制造恐惧，是导演郭帆在采访中反复提到的问题。',
      '"我们刻意回避了那些一眼就能看清的怪物，"郭帆说，"真正让人害怕的，是你知道有什么东西在附近，却永远看不到它。"为了达到这种效果，团队大量使用了次声波与低频音效。',
      '影片中的深海景观同样令人震撼。美术团队参考了大量真实的海洋生物影像，将生物荧光、热泉喷口等元素融入场景，营造出一个既美丽又危险的世界。',
      '郭帆透露，团队正在筹备一部以"极地"为背景的姊妹篇，希望能延续这种沉浸式的惊悚体验。',
    ],
    cover: 'https://readdy.ai/api/search-image?query=deep%20ocean%20trench%20with%20bioluminescent%20light%20and%20a%20submarine%2C%20news%20article%20header%20visual%2C%20deep%20midnight%20blue%20and%20warm%20orange%20grading%2C%20dramatic%20lighting%2C%20highly%20detailed%2C%20no%20text&width=1200&height=675&seq=yz-n3-cover&orientation=landscape',
    category: 'movie',
    publishedAt: '2026-10-08',
    author: '影评人 阿哲',
    relatedIds: ['m7', 'm1'],
  },
  {
    id: 'n4',
    title: '秋季档观影指南：这五部电影值得你走进影院',
    summary:
      '秋意渐浓，院线也迎来了佳作密集的档期。从科幻到爱情，从悬疑到历史，我们为你精选五部不容错过的影片。',
    content: [
      '随着气温转凉，院线大盘却持续升温。本月多部备受期待的作品集中上映，类型之丰富堪称近年少见。',
      '如果你偏爱宏大叙事，《星际回响》与《孤城》无疑是首选；前者用时间悖论叩问人性，后者则以一场孤城保卫战书写悲壮史诗。',
      '喜欢烧脑悬疑的观众，可以关注港片《暗夜追凶》与英伦推理《迷雾侦探》，两部作品都在类型框架内玩出了新意。',
      '至于想被温柔治愈一下的朋友，《春日来信》会是一个很好的选择。一封跨越十年的信，足以让人相信爱情的漫长与美好。',
    ],
    cover: 'https://readdy.ai/api/search-image?query=cinema%20hall%20with%20rows%20of%20empty%20seats%20lit%20by%20warm%20projector%20light%2C%20news%20article%20header%20visual%2C%20deep%20midnight%20blue%20and%20warm%20orange%20grading%2C%20highly%20detailed%2C%20no%20text&width=1200&height=675&seq=yz-n4-cover&orientation=landscape',
    category: 'movie',
    publishedAt: '2026-10-06',
    author: '御宅屋编辑部',
    relatedIds: ['m1', 'm5', 'm6'],
  },
  {
    id: 'n5',
    title: '《医者仁心》口碑逆袭：现实题材为什么持续走红',
    summary:
      '开播初期排片平平的《医者仁心》，凭借真实细腻的急诊群像一路逆袭，成为本季度讨论度最高的现实题材剧集。',
    content: [
      '《医者仁心》并非传统意义上的"爆款开局"，开播时甚至没有太多的宣传声量。但随着剧集推进，越来越多的观众开始自发安利。',
      '剧集最大的特点，在于它没有把主角塑造成无所不能的"神医"，而是耐心地呈现每一次抉择背后的纠结与代价。',
      '有观众评论说："它让我第一次理解了，医生在手术台前的每一秒犹豫，都不是因为不专业，恰恰是因为太在乎。"',
      '现实题材近年来持续升温，或许正是因为观众越来越希望从影视作品中，看到与自己生活真正相关的故事。',
    ],
    cover: 'https://readdy.ai/api/search-image?query=bright%20modern%20hospital%20corridor%20with%20medical%20team%20walking%2C%20news%20article%20header%20visual%2C%20deep%20midnight%20blue%20and%20warm%20orange%20grading%2C%20clean%20highly%20detailed%2C%20no%20text&width=1200&height=675&seq=yz-n5-cover&orientation=landscape',
    category: 'tv',
    publishedAt: '2026-10-04',
    author: '追剧小组',
    relatedIds: ['t4', 't2'],
  },
  {
    id: 'n6',
    title: '影评｜《春日来信》：一封写给时光的温柔情书',
    summary:
      '《春日来信》没有惊心动魄的情节，却用一封信、一个约定、一场春天，把暗恋的漫长与美好拍得淋漓尽致。',
    content: [
      '如果要用一句话概括《春日来信》，那大概是：所有没被说出口的喜欢，最终都会被时间温柔以待。',
      '影片的叙事节奏很慢，慢得像小镇的春天。但正是这种慢，让每一次信件的往来都充满了重量。导演把大量的镜头给了邮局、信箱、以及女孩等待时的侧脸。',
      '最动人的一场戏发生在影片结尾。当那个约定终于被兑现，镜头没有给到煽情的特写，而是缓缓拉远，让整片花海替人物说出了一切。',
      '这是一部适合一个人安静看完的电影。它不试图说服你相信爱情，只是轻轻告诉你，等待本身，也有它的意义。',
    ],
    cover: 'https://readdy.ai/api/search-image?query=spring%20flower%20field%20with%20a%20wooden%20mailbox%20at%20golden%20hour%2C%20news%20article%20header%20visual%2C%20deep%20midnight%20blue%20and%20warm%20orange%20grading%2C%20warm%20highly%20detailed%2C%20no%20text&width=1200&height=675&seq=yz-n6-cover&orientation=landscape',
    category: 'review',
    publishedAt: '2026-10-02',
    author: '影评人 晚风',
    relatedIds: ['m5'],
  },
  {
    id: 'n7',
    title: '深度｜国产科幻的十年进化：从模仿到自成一派',
    summary:
      '过去十年，国产科幻从小心翼翼的"学徒期"，一路走到了今天能与世界对话的成熟阶段。这条路，究竟经历了什么？',
    content: [
      '十年前，提起国产科幻，大多数观众的第一反应还是"五毛特效"。而今天，《星际回响》《星海远征》等作品已经能够在全球市场获得认可。',
      '这种转变并非一蹴而就。它背后是工业体系的逐步完善，是创作者对科学精神的尊重，更是整个行业愿意为"慢工出细活"买单的耐心。',
      '更重要的是叙事上的成熟。早期的国产科幻往往急于展示设定，而现在，越来越多的作品开始把科幻当作探讨人性的舞台。',
      '下一个十年，国产科幻或许会走向更加多元的方向。技术会不断进步，但真正打动观众的，永远是那些关于人本身的故事。',
    ],
    cover: 'https://readdy.ai/api/search-image?query=futuristic%20spaceship%20fleet%20flying%20through%20a%20colorful%20nebula%2C%20news%20article%20header%20visual%2C%20deep%20midnight%20blue%20and%20warm%20orange%20grading%2C%20epic%20highly%20detailed%2C%20no%20text&width=1200&height=675&seq=yz-n7-cover&orientation=landscape',
    category: 'review',
    publishedAt: '2026-09-30',
    author: '御宅屋编辑部',
    relatedIds: ['m1', 't3'],
  },
  {
    id: 'n8',
    title: '《都市浮生》第二季正式开机，原班人马悉数回归',
    summary:
      '备受好评的都市群像剧《都市浮生》宣布第二季开机，主要演员悉数回归，新一季将聚焦"三十岁之后的人生选择"。',
    content: [
      '今日，《都市浮生》官方发布第二季开机照，主演黄磊、海清、白宇等悉数亮相，宣布新一季正式进入拍摄阶段。',
      '据主创介绍，第二季的时间线将推后三年，故事聚焦角色们"三十岁之后"的人生选择——事业的瓶颈、家庭的重担、以及重新出发的勇气。',
      '第一季凭借真实细腻的都市群像收获了不俗口碑，许多观众表示在角色身上看到了自己的影子。第二季能否延续这种共鸣，值得期待。',
      '该剧预计将于明年与观众见面，御宅屋会持续跟进后续资讯。',
    ],
    cover: 'https://readdy.ai/api/search-image?query=modern%20city%20street%20at%20night%20with%20young%20people%20walking%20and%20city%20lights%2C%20news%20article%20header%20visual%2C%20deep%20midnight%20blue%20and%20warm%20orange%20grading%2C%20urban%20highly%20detailed%2C%20no%20text&width=1200&height=675&seq=yz-n8-cover&orientation=landscape',
    category: 'tv',
    publishedAt: '2026-09-28',
    author: '追剧小组',
    relatedIds: ['t2', 't4'],
  },
];